import BaseIcon from "./BaseIcon";
import React, { ReactElement, SVGProps } from "react";

export default function CaretUp(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M13.2649 10.2649C13.1946 10.3351 13.0993 10.3746 12.9999 10.3746C12.9005 10.3746 12.8052 10.3351 12.7349 10.2649L7.99992 5.53054L3.26492 10.2649C3.19384 10.3312 3.09981 10.3672 3.00266 10.3655C2.90551 10.3638 2.81282 10.3244 2.74411 10.2557C2.67541 10.187 2.63605 10.0943 2.63434 9.99718C2.63262 9.90002 2.66868 9.806 2.73492 9.73491L7.73492 4.73491C7.80524 4.66469 7.90055 4.62524 7.99992 4.62524C8.0993 4.62524 8.19461 4.66469 8.26492 4.73491L13.2649 9.73491C13.3351 9.80523 13.3746 9.90054 13.3746 9.99991C13.3746 10.0993 13.3351 10.1946 13.2649 10.2649Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
